export const Footer = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="footerCont fixed bottom-0 h-80px items-center flex justify-center w-full border-t-solid border-t-4 border-t-[#D2DAE1]">
      <div className="footer flex justify-between">{children}</div>
    </div>
  );
};
